module.exports = __webpack_public_path__ + "fonts/Lato-BlackItalic.0f4fa975.woff2";